import { Injectable } from '@angular/core';
import { BaseFacade } from '../base/base.facade';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { AppTokenService } from '../../../app-token.service';
import { ClaimService } from './claim.service';
import { ClaimStore } from './claim.store';
import { ClaimQuery } from './claim.query';

@Injectable({ providedIn: 'root' })
export class ClaimFacade extends BaseFacade {

  constructor(
    private readonly claimService: ClaimService,
    claimStore: ClaimStore,
    claimQuery: ClaimQuery,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService) {
    super(claimService,
      claimStore,
      claimQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade(AppTokenService.CLAIM_SCHEMA_NAME),
      translateService,
      AppTokenService.CLAIM_SCHEMA_NAME + '-facade'
      );
  }
}
